<template>
    <!-- 添加数据2 -->
    <a-modal title="发布通知" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a class="leftLb"><span class="startColor">*</span>标 题：</a>
            <a-input v-model:value="pushData.title" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a class="leftLb"><span class="startColor">*</span>正 文：</a>
            <a-textarea style="width: 80%;" v-model:value="pushData.content" :rows="4" :maxlength="1000" />
        </div>

        <div class="push-input">
            <a><span class="startColor">*</span>发布类型：</a>
            <a-select v-model:value="pushData.type" class="push-data">
                <a-select-option key="通知" value="通知">通知</a-select-option>
                <a-select-option key="公告" value="公告">公告</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>优 先 级：</a>
            <a-select v-model:value="pushData.priority" class="push-data">
                <a-select-option key="普通" value="普通">普通</a-select-option>
                <a-select-option key="加急" value="加急">加急</a-select-option>
                <a-select-option key="紧急" value="紧急">紧急</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a>指定部门：</a>
            <a-select v-model:value="pushData.targetDepartmentId" class="push-data">
                <a-select-option key="" value="">无</a-select-option>
                <a-select-option v-for="p in depts" :key="p.id" :value="p.id">{{ p.deptName }}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a>指定人员：</a>
            <a-select v-model:value="pushData.targetUserId" class="push-data">
                <a-select-option key="" value="">无</a-select-option>
                <a-select-option v-for="p in users" :key="p.id" :value="p.id">{{ p.username
                    }}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a>有效时间：</a>
            <a-date-picker v-model:value="pushData.endTime" />
        </div>
        <div class="push-file">
            <a style="width: 100%;">上传附件：</a>
            <a-upload v-model:file-list="fileList" maxCount=1 name="file" :headers="getUploadHeaders()"
                action="http://127.0.0.1:9090/simpleAdmin/common/uploadAnnFile" @success="fileSuccess"
                @change="handleChange">
                <a-button>
                    <upload-outlined></upload-outlined>
                    点击选择文件
                </a-button>
            </a-upload>

        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveAnnounce, listDepts, userLists, pushAnnFile } from '@/api/service';
import { generateSignHeaders } from '@/utils/sign';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'addComponent',
    methods: {
        getUploadHeaders() {
            return {
                'token': localStorage.getItem('token'),
                'tenantId': localStorage.getItem('tenantId'),
                ...generateSignHeaders()
            };
        }
    },
    setup() {
        const loading = ref(false);//添加提交时的加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        const depts = ref([]);//父级菜单
        const users = ref([]);//父级菜单
        const attachmentUrl = ref('');//附件
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
        //查询部门列表
        const listDept = async () => {
            const response = await listDepts();
            if (response.code === 200) {
                depts.value = response.data;
            }
        }
        //查询权限列表
        const userList = async () => {
            const response = await userLists();
            if (response.code === 200) {
                users.value = response.data;
            }
        }

        /**
         * 处理文件上传状态改变
         *
         * @param info 文件上传状态信息
         * @returns 无返回值
         */
        const handleChange = info => {
            console.log(info.file.status);
            if (info.file.status === 'uploading') {
                message.info('上传中');
            }
            if (info.file.status === 'removed') {
                message.info('删除成功');
            }
            if (info.file.status === 'error') {
                message.error('上传失败');
            }
            if (info.file.status === 'done') {
                message.success('上传成功');
            } 
        };

        /**
         * 附件上传成功回调函数
         *
         */
        const fileSuccess = (response) => {
            attachmentUrl.value = response.data;
            console.log(response.data)
        }

        //提交数据
        const handleOk = async () => {
            pushData.value.attachmentUrl = attachmentUrl.value;
            loading.value = true;
            const response = await saveAnnounce(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                loading.value = true;
                pushData.value = {};
                attachmentUrl.value = '';
                loading.value = true;
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                loading.value = true;
                open.value = false;
                return false;
            }
        }
        listDept();
        userList();
        return {
            loading,
            open,
            pushData,
            listDept,
            userList,
            pushAnnFile,
            users,
            attachmentUrl,
            handleChange,
            fileSuccess,
            depts,
            parent,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}

.push-file {
    margin-top: 20px;
    margin-bottom: 50px;
    display: inline-flex;
    align-items: center;
    width: 100%;
}

.modals {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 500px;
}

.push-data {
    width: 80%;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.leftLb {
    margin-left: 4.5%;
}
</style>